module.exports = __webpack_public_path__ + "static/media/stage_1.3e887e95.jpg";